































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import homePage from "@/components/homePage.vue";
import landmarkFamily from "@/components/landmarkFamily.vue";
import enterpriseMien from "@/components/enterpriseMien.vue";
import cultureHeritage from "@/components/cultureHeritage.vue";
import vrVideo from "@/components/vrVideo.vue";
import landmarkShop from "@/components/landmarkShop.vue";
import policies from "@/components/policies.vue";
import { getCmsHomeDataList, getCmsHomeFirstPage, headerData } from "@/axios";
import { AppModule } from "@/store/app";

@Component({
  name: "landmarkVr",
  components: {
    "v-homePage": homePage,
    "v-landmarkFamily": landmarkFamily,
    "v-enterpriseMien": enterpriseMien,
    "v-cultureHeritage": cultureHeritage,
    "v-vrVideo": vrVideo,
    "v-landmarkShop": landmarkShop,
    "v-policies": policies,
  },
})
export default class extends Vue {
  // 导航索引
  private navIndex: any = 1;
  private navIndexOld: any = 1;
  // 导航数据
  private navData: any = [];

  // 首页数据数据
  private inputPageHomeData: any = null;

  // 地标家族数据
  private inputLandmarkFamilyData: any = null;

  // 地标商城
  private inputLandmarkShopData: any = null;

  // 企业风采数据
  private inputEnterpriseMienData: any = null;

  // 文化传承数据
  private inputCultureHeritageData: any = null;

  // vr视频数据
  private inputVrVideoData: any = null;

  // 政策法规
  private inputRule: any = null;

  private scrollBar: any = true;

  private searchValue: any = "";

  private landmarkTitle: any = "";

  private getImgUrl(id: any) {
    return require("@/assets/images/indexNavIcon" + id + ".png");
  }

  // 改变nav索引
  private changeNavIndex(id: any) {
    console.log("changeNavIndex=========", id);

    this.navIndex = id;
    this.scrollBar = true;
    if (id != 2) {
      this.navIndexOld = id;
    }

    //获取homePage组件里面的鼠标监听事件
    if (id == 1) {
      (this as any).$refs.homePage.addListscroll();
    } else {
      (this as any).$refs.homePage.RemoveList();
    }
  }
  private RemoveList() {}

  private setSize() {
    this.$nextTick(() => {
      var viewHeight: any = $(window).height();
      var contentHeight: any = $(".template-box").height();
      if (viewHeight > contentHeight) {
        this.scrollBar = false;
      } else {
        this.scrollBar = true;
      }
    });
  }

  created() {
    headerData({
      landmark_id: "",
    }).then((res: any) => {
      let data = res.data.data;
      this.navData = data.headerData;
      this.landmarkTitle = "福建省地理标志农产品数字服务平台";
    });

    window.onresize = () => {
      this.setSize();
    };

    // 首页数据
    getCmsHomeFirstPage({
      v: 2, //版本2.0 接口部分字段和1.0不同，但用同一个接口，多加参数v=2
    })
      .then((res: any) => {
        let data = res.data.data;
        this.inputPageHomeData = data.pageHome;
        this.navData = data.headerData;

        this.setSize();
      })
      .catch((error: any) => {});

    //除首页外的所有数据
    getCmsHomeDataList({})
      .then((res: any) => {
        let data = res.data.data;
        this.inputLandmarkFamilyData = data.pageLandmark;
        this.inputEnterpriseMienData = data.pageEnterprise.enterpriseArray;
        this.inputCultureHeritageData = data.pageCulture.landmarkCultureArray;
        this.inputLandmarkShopData = data.pageShop[0];
        this.inputVrVideoData = data.pageVrVideo;
        this.inputRule = data.pageRule;
        // console.log('getCmsHomeDataList----------------------',data)
      })
      .catch((error: any) => {});
  }

  mounted() {
    if (AppModule.landMarkId) {
      this.changeNavIndex(7);
    }
  }

  private toOther() {
    window.location.href = "https://cms.fjyoulunsw.com/web_new/#/login";
  }

  private toIndex() {
    this.$router.push({
      path: "/",
    });
  }

  private toSearch(value: any) {
    if (value.length != 0) {
      this.$router.push({
        path: "/search",
        query: { searchValue: value },
      });
    }
  }

  private closeLandmarkDialog() {
    this.landmarkDialogShow = false;
  }

  private landmarkDialogShow: any = false;
  private landmarkUrl: any = "";

  private showLandmark() {
    // alert(document.location.protocol);
    // var url = document.location.protocol + "//cms.fjyoulunsw.com/sign_vr/#/";
    var url =
      document.location.protocol +
      "//cms.fjyoulunsw.com/sign_vr_v2/#/aPicture?id=1";
    this.landmarkUrl = url;
    this.landmarkDialogShow = true;
  }

  private toLandmarkIndex(index: any) {
    if (index == 2) {
      this.showLandmark();
    }
  }
}
